import React from 'react'
import styled from 'styled-components'
import media from 'utils/media'

const StyledHamburger = styled.button`
   background-color: ${({ theme, isOpen }) => (isOpen ? theme.colors.headerBtnBgOpen : theme.colors.headerBtnBgClose)};
   border: none;
   border-radius: 6px;
   cursor: pointer;
   padding: 10px;
   display: flex;
   width: 40px;
   height: 40px;
   justify-content: center;
   align-items: center;
   transition: background-color 0.20s ease-in-out;

   ${media.greaterThan('lg')`
      display: none;
   `};

   div {
      display: flex;
      flex-direction: column;
      gap: 2px;
      position: relative;
      width: 14px;
      height: 10px;
   }

   span {
      display: block;
      height: 2px;
      background-color: ${({ theme, isOpen }) =>
         theme.darkMode ? theme.colors.white : isOpen ? theme.colors.white : theme.colors.accent};
      border-radius: 2px;
      position: ${({ isOpen }) => (isOpen ? 'absolute' : 'relative')};
      transition: all 0.20s ease-in-out;

      &:nth-child(1) {
         width: 14px;
         top: ${({ isOpen }) => (isOpen ? '50%' : 'auto')};
         transform: ${({ isOpen }) => (isOpen ? 'translateY(-50%) rotate(45deg)' : 'rotate(0)')};
         transform-origin: center;
      }

      &:nth-child(2) {
         width: 9px;
         opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
         transition: opacity 0.15s ease-in-out;
      }

      &:nth-child(3) {
         width: 5px;
         top: ${({ isOpen }) => (isOpen ? '50%' : 'auto')};
         transform: ${({ isOpen }) => (isOpen ? 'translateY(-50%) rotate(-45deg)' : 'rotate(0)')};
         transform-origin: center;
      }
   }

   ${({ isOpen }) =>
      isOpen &&
      `
      span:nth-child(1),
      span:nth-child(3) {
         width: 14px;
      }
   `}
`

const HamburgerBtn = ({ onClick, isOpen }) => {
   return (
      <StyledHamburger onClick={onClick} isOpen={isOpen} aria-label={isOpen ? 'close menu' : 'open menu'}>
         <div>
            <span />
            <span />
            <span />
         </div>
      </StyledHamburger>
   )
}

export default HamburgerBtn
